/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState, useMemo } from "react";
import { masterRateCardAPI, zoneAPI } from "../../api/RateCardApi";
import { message } from "antd";
import DynamicRateCard from "./DynamicRateCard";

const RateCardMatrix = ({
  getData,
  setMatrixData = () => {},
  actionEdit = true,
  customerId,
  rateCardType,
  //notCloneZone = false,
  setRateCardOptionTypes = () => {},
  rateCardError = [],
  getAllDefaultZones = () => {},
  showValueChangedPercentage = false,
  disableNewWeightSlabs = false,
  editHighValue = false,
  showHighLight = false,
  rateCardId = null,
}) => {
  const [rateCardMatrix, setRateCardMatrix] = useState({});
  const [shippingType, setShippingType] = useState([]);
  const [docType, setDocType] = useState([]);
  const [travelModeType, setTravelModeType] = useState([]);
  const [defaultZones, setDefaultZones] = useState([]);
  const [defaultRateCardMatrix, setDefaultRateCardMatrix] = useState({});
  const [highlightedTypes, setHighLightedTypes] = useState([]);
  //const [originalMatrixData, setOriginalMatixData] = useState({});

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchDefaultRateCardMatrix();
    }, 100);
    return () => clearTimeout(timer);
  }, [getData]);

  const fetchDefaultRateCardMatrix = async () => {
    try {
      const res = await masterRateCardAPI.getDefaultRateMatrix();
      if (!res?.status) {
        message.error(res?.response?.data?.message || "Internal server error");
        return;
      }

      const data = res.response?.data || {};
      const isValidData =
        getData &&
        typeof getData === "object" &&
        Object.keys(getData).length > 0;
      setDefaultRateCardMatrix(data || {});
      const source = isValidData ? getData : data;

      const docTypeKeys = Object.keys(source);
      const travelModeKeys = Object.keys(source[docTypeKeys[0]] || {});
      const shippingTypeKeys = Object.keys(
        source[docTypeKeys[0]]?.[travelModeKeys[0]] || {}
      );

      if (showHighLight) {
        let hightLightTypeObjMap = {};
        let hightLightTypeArr = [];

        docTypeKeys?.forEach((doc) => {
          travelModeKeys?.forEach((travelMode) => {
            const key = `${doc}|${travelMode}`;

            shippingTypeKeys?.forEach((shipping) => {
              const innerTemp = getData?.[doc]?.[travelMode]?.[shipping];
              if (!hightLightTypeObjMap[key]) {
                hightLightTypeObjMap[key] = {
                  doc,
                  travelMode,
                  [shipping]: innerTemp,
                };
                hightLightTypeArr.push(hightLightTypeObjMap[key]);
              } else {
                hightLightTypeObjMap[key][shipping] = innerTemp;
              }
            });
          });
        });

        const areArraysDifferent = (arr1, arr2) => {
          if (!Array.isArray(arr1) || !Array.isArray(arr2)) return true;
          if (arr1.length !== arr2.length) return true;

          return arr1.some((obj1, index) => {
            const obj2 = arr2[index];
            const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
            for (let key of keys) {
              if (obj1[key] != obj2[key]) return true;
            }
            return false;
          });
        };

        // Main logic
        const getChangedDocShippingKeys = (dataArray) => {
          const changedItems = [];
          dataArray.forEach((item) => {
            for (const key in item) {
              if (key.endsWith("_old")) {
                const originalKey = key.replace("_old", "");
                const oldValue = item[key];
                const newValue = item[originalKey];

                if (areArraysDifferent(newValue, oldValue)) {
                  // Serialize the triplet to a string and add to the Set
                  changedItems.push(item.doc, item.travelMode, originalKey);
                }
              }
            }
          });

          return changedItems;
        };

        const result = getChangedDocShippingKeys(hightLightTypeArr);
        const uniqueResult = [...new Set(result)];

        setHighLightedTypes(uniqueResult);
      }

      updateStateIfChanged(setDocType, docTypeKeys);
      updateStateIfChanged(setTravelModeType, travelModeKeys);
      updateStateIfChanged(setShippingType, shippingTypeKeys);

      setRateCardOptionTypes({
        docType: docTypeKeys,
        travelMode: travelModeKeys,
        shippingType: shippingTypeKeys,
      });

      const defaultZoneData =
        data?.[docTypeKeys[0]]?.[travelModeKeys[0]]?.[shippingTypeKeys[0]] ||
        [];
      const defaultZoneKeys = Object.keys(defaultZoneData[0] || {});
      setDefaultZones(defaultZoneKeys);
      getAllDefaultZones(defaultZoneKeys);
      //setOriginalMatixData({ ...getData });
      setRateCardMatrix(source);
    } catch (error) {
      console.error("RateCard Fetch Error:", error);
      message.error("Failed to fetch rate card matrix");
    }
  };

  // const isRateCardModified = (original, updated) => {
  //   return original.some((origItem, index) => {
  //     const updatedItem = updated[index];
  //     if (!updatedItem) return true;

  //     for (let key in origItem) {
  //       // Compare only if key exists in both objects
  //       // eslint-disable-next-line no-prototype-builtins
  //       if (updatedItem.hasOwnProperty(key)) {
  //         if (origItem[key] !== updatedItem[key]) {
  //           return true;
  //         }
  //       }
  //     }

  //     return false;
  //   });
  // };

  const updateStateIfChanged = (setState, newValue) => {
    setState((prev) =>
      JSON.stringify(prev) !== JSON.stringify(newValue) ? newValue : prev
    );
  };

  //console.log(originalMatrixData, getData);

  //const memoizedMatrixData = useMemo(() => rateCardMatrix, [rateCardMatrix]);
  const memoizedDocType = useMemo(() => docType, [docType]);
  const memoizedTravelMode = useMemo(() => travelModeType, [travelModeType]);
  const memoizedShippingType = useMemo(() => shippingType, [shippingType]);

  useEffect(() => {
    setMatrixData(rateCardMatrix);
  }, [rateCardMatrix]);

  //console.log(shippingType, "jj");

  const changeMatrixData = (
    val,
    selectedDocType,
    selectedTravelModeType,
    selectedShippingType
  ) => {
    let temp = rateCardMatrix;
    temp[selectedDocType][selectedTravelModeType][selectedShippingType] = val;

    setRateCardMatrix({ ...temp });
  };

  //console.log(rateCardMatrix, "rateCardMatrix", memoizedMatrixData);

  const deleteZone = (val) => {
    let temp = rateCardMatrix;
    docType?.forEach((doc) => {
      travelModeType?.forEach((travelMode) => {
        shippingType?.forEach((shipping) => {
          let innerTemp = temp[doc][travelMode][shipping];
          innerTemp.forEach((item) => {
            delete item[val];
          });
        });
      });
    });
    setRateCardMatrix({ ...temp });
  };

  const addZone = async (
    values,
    actionType,
    editSelectedZone
    ///addZoneId,
    //actionCreate
  ) => {
    // let payload = {
    //   name: values.name,
    //   userId: customerId?.toString(),
    //   rateCategory: rateCardType, // [account, cash]
    //   parentZone: {
    //     id: addZoneId,
    //   },
    // };
    // const headers = {
    //   parent: "HO",
    // };
    let temp = rateCardMatrix;

    // if (!actionCreate && !notCloneZone) {
    //   const res = await zoneAPI.cloneZone(payload, headers);
    //   if (res?.status) {
    //     updateRateCardMatrix(temp, actionType, editSelectedZone, values);
    //     setRateCardMatrix({ ...temp });
    //   } else {
    //     message.error(res?.response?.data?.message || "Internal server error");
    //   }
    // } else {
    updateRateCardMatrix(temp, actionType, editSelectedZone, values);
    setRateCardMatrix({ ...temp });
    ///}
  };

  const updateRateCardMatrix = (temp, actionType, editSelectedZone, val) => {
    docType?.forEach((doc) => {
      travelModeType?.forEach((travelMode) => {
        shippingType?.forEach((shipping) => {
          const innerTemp = temp?.[doc]?.[travelMode]?.[shipping];
          if (Array.isArray(innerTemp)) {
            innerTemp.forEach((item) => {
              if (actionType === "add") {
                item[val.name] = 0;
              } else if (
                editSelectedZone in item &&
                item[editSelectedZone] !== undefined
              ) {
                item[val.name] = item[editSelectedZone];
                delete item[editSelectedZone];
              }
            });
          }
        });
      });
    });
  };

  return (
    <div>
      <DynamicRateCard
        actionEdit={actionEdit}
        customerId={customerId}
        rateCardType={rateCardType}
        travelModeType={memoizedTravelMode}
        docType={memoizedDocType}
        shippingType={memoizedShippingType}
        matrixData={rateCardMatrix}
        originalMatrixData={JSON.stringify(getData)}
        deleteZone={(val) => deleteZone(val)}
        addZone={(
          values,
          actionType,
          editSelectedZone,
          addZoneId,
          actionCreate
        ) =>
          addZone(values, actionType, editSelectedZone, addZoneId, actionCreate)
        }
        defaultZones={defaultZones}
        onChangeMatrixData={(
          data,
          selectedDocType,
          selectedTravelMode,
          selectedShippingType
        ) =>
          changeMatrixData(
            data,
            selectedDocType,
            selectedTravelMode,
            selectedShippingType
          )
        }
        rateCardError={rateCardError}
        defaultRateCardMatrix={defaultRateCardMatrix}
        showValueChangedPercentage={showValueChangedPercentage}
        disableNewWeightSlabs={disableNewWeightSlabs}
        editHighValue={editHighValue}
        showHighLight={showHighLight}
        highlightedTypes={highlightedTypes}
        rateCardId={rateCardId}
      />
    </div>
  );
};

export default RateCardMatrix;
